import React, {useState} from 'react';
import {HtmlParse} from 'utils';
import PropTypes from 'prop-types';
import style from './style.scss'//NOSONAR

const TextComponent = (props) => {

    const {data} = props;
    const [isExpanded, setIsExpanded] = useState(false);

    const paragraph = data?.paragraph
    const showSeeMore = (paragraph?.length >= 250);

    const toggleParagraph = () => {
        setIsExpanded(!isExpanded)
    }

    if(!data) return '';

    return <section className='text-component-container'>
        <div className="text-component-title-wrapper">
            <h2 className="text-component-medium-title">{data.title}</h2>
            {paragraph && showSeeMore && (<span className="text-component-medium-link" onClick={toggleParagraph}>{(isExpanded) ? 'Ocultar':'Ver más'}
                <a className={"font-icn" + ((isExpanded) ? ' arrow-up' : ' arrow-down') }></a></span>)}
        </div>
        {paragraph && (
            <span className={`text-component-block-paragraph ${!isExpanded && showSeeMore && 'text-component-block-paragraph-mobile'}`}><>{HtmlParse(paragraph)}</></span>
        )}
    </section>;
}

TextComponent.propTypes = {
    data: PropTypes.object,
};

export default TextComponent;
